import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { HttpErrorResponse } from "../../../types/responses";
import { useApiPssLogoAdd } from "../datasources/_pss.logopicture.api.slice";

const usePssAprsLogoAddRepo = () => {
  const [api, repository] = useApiPssLogoAdd();
  const httpError = repository.error
    ? ((repository.error as FetchBaseQueryError).data as HttpErrorResponse)
    : undefined;

  return [
    {
      ...repository,
      error: httpError,
    },
    api,
  ] as const;
};

export default usePssAprsLogoAddRepo;
